import api from "./api";

export const checkVacancies = (professionalId,date) => {
	return api.get(
		"professional/" + professionalId + "/vacancies?date=" + date
	);
};

const vacanciesService = {
	checkVacancies
};

export default vacanciesService;
